<template>
  <div id="IndexSISEVA_div">

    <menusuperior titulo="SISEVA" subtitulo="Sistema de Evaluación de Personal"></menusuperior>
    <menuizquierda></menuizquierda>

    <div v-if="$route.fullPath == RUTA_RAIZ_SISEVA" class="d-flex justify-content-center align-items-center content-area">
      <div id="secciondebienvenidaSISEVA" class="d-flex flex-wrap align-items-center justify-content-center">
        <figure class="text-center">
          <img src="../../../assets/paginaoficial/Logotipo_Positivo_Horizontal.png" alt="Logo de Poder Judicial del Estado de Aguascalientes" />
        </figure>
        <h2 >BIENVENIDOS AL SISTEMA SISEVA</h2>
        <h4></h4>
      </div>
    </div>

    <div v-show="$route.fullPath != RUTA_RAIZ_SISEVA" class="content-area">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>

    <!-- <main class="content-area">
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </main> -->
  </div>
</template>
<script>
  import menusuperior from '@/components/Comunes/MenuSuperior.vue'
  import menuizquierda from '@/components/Comunes/MenuIzquierdaDeLosSistemas.vue'

  export default {
    name: 'Plantilla',
    components: {
      menusuperior,
      menuizquierda
    },
    data() {
      return {
        RUTA_RAIZ_SISEVA: '/SISEVA'
      }
    }
  }
</script>
<style >
  input[type=button],
  button {cursor: pointer;}
  input[type=button]:hover,
  button:hover {background-color: #007bff;}
  td a i {
    color:#343a40!important;
  }
   button {
    overflow: hidden
  }

  .prof-pic {
    font-size: 7vw;
    max-width: 400px;
  }
  td i {
    cursor:pointer;
  }
  th i {
    cursor:pointer;
  }
  .thumb {
  object-fit: cover;
  width:10vw;
  height:10vw;
}
#secciondebienvenidaSISEVA {
    width: 40vw;
    height: 600px;
    align-content: center;
  }

  #secciondebienvenidaSISEVA h2 {
    margin-top: 3vh;
    text-align: center;
    color: var(--gris-pj);
  }

  #secciondebienvenidaSISEVA h4 {
    margin-top:1vh;
  }

  @media (max-width: 991px) {
    #secciondebienvenidaSISEVA h2 {
      font-size: .9rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Comun/Plantilla.vue